import React, { useEffect, useState } from "react";
import { DeleteOutlined, FilePdfOutlined, UploadOutlined } from "@ant-design/icons";
import { Modal, Popover, Space, Upload } from "antd";
import "./FileUploadWithThumb.css";
import { ConvertByteToMb, getBase64 } from "../../common/Constants";
import { toast } from "react-toastify";

const FileUpload = (props) => {
  const { label, action, maxCount = 1, onFileUpload, CustomFileUpload, onRemove, files } = props
  const [fileList, setFileList] = useState(files !== undefined && files?.length > 0 ? files : []);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewType, setPreviewType] = useState('');


  const beforeUpload = (file) => {
    return fileList.length < maxCount;
  };

  const onChange = ({ file, fileList: newFileList }) => {

    if (ConvertByteToMb(file.size) <= 5) {
      setFileList(newFileList);
      onFileUpload(newFileList)
    }
    else {
      toast.error("File size must be less than 5mb..")
    }
  };

  useEffect(() => {
    if (files !== undefined && files?.length > 0) {
      setFileList(files);
    } else {
      setFileList([]);
    }
  }, [files]);


  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const extension = file.name.split('.').pop().toLowerCase();
    if (extension === 'pdf' || extension === 'doc' || extension === 'docx') {
      setPreviewType('doc');
    } else {
      setPreviewType('img');
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };


  return (
    <div className="file-upload-section uploadCard">
      <div className="file-upload-head">
        <h2>{label}</h2>
        <Popover content={"Coming soon"} className="mt-[-4px]">
          <img
            src="/images/fi_info.svg"
            alt="info"
            className="inline-block ml-[8px] cursor-pointer"
          />
        </Popover>
      </div>
      <Modal
        open={previewOpen}
        title={previewTitle}
        centered footer={null}
        onCancel={() => setPreviewOpen(false)}
        width={"80%"}
      >
        {
          previewType === 'img' ? (
            <img
              alt="example"
              style={{
                width: '100%',
              }}
              src={previewImage}
            />
          ) : (
            <iframe src={previewImage} className='w-full' height={800} />
          )
        }
      </Modal>
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Upload
          action={action}
          customRequest={CustomFileUpload}
          listType="picture"
          maxCount={maxCount}
          beforeUpload={beforeUpload}
          onChange={onChange}
          onRemove={onRemove}
          fileList={fileList}
          onPreview={handlePreview}
          multiple={true}
          itemRender={(originNode, file, currFileList) => {
            return (
              <div
                style={{
                  border: '1px solid #e5e5e5',
                  borderRadius: 8,
                  padding: 12,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  maxWidth: 400,
                  backgroundColor: '#fff',
                  marginBottom: 12,
                  wordBreak: 'break-word',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flexWrap: 'wrap', }} onClick={() => handlePreview(file)}>
                  <FilePdfOutlined style={{ fontSize: 32, color: '#1677ff', marginRight: 8 }} />
                  <span style={{ fontWeight: 500 }}>{file.name}</span>
                </div>

              </div>
            );
          }}


          accept=".png,.jpeg,.jpg,.docx,.doc,.pdf"
        >
          <button
            type="button"
            disabled={fileList.length >= maxCount}
            className="file-upload-btn"
          >
            Max: {maxCount} file{maxCount > 1 ? "s" : ""}
            <span>
              <UploadOutlined /> Upload
            </span>
          </button>
        </Upload>
      </Space>
    </div>
  );
};

export default FileUpload;
